module.exports = __webpack_public_path__ + "img/a123_7.71347ad5.webp";